var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.445,11.774c3.497-.021,5.303-1.83,5.367-5.395-.059-3.446-1.965-5.379-5.373-5.379-3.494,0-5.368,1.987-5.368,5.396,0,3.498,1.92,5.357,5.374,5.377Zm-.006-9.774c2.853,.019,4.323,1.498,4.373,4.378-.055,2.982-1.444,4.379-4.367,4.396-2.927-.017-4.316-1.411-4.374-4.387,.055-2.934,1.486-4.369,4.368-4.387Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.439,14.294c-5.256,.033-8.084,2.868-8.179,8.197-.005,.276,.215,.504,.491,.509h.009c.272,0,.495-.218,.5-.491,.086-4.825,2.436-7.185,7.179-7.215,4.685,.03,7.102,2.458,7.184,7.215,.005,.276,.223,.496,.509,.491,.276-.005,.496-.232,.491-.509-.091-5.252-2.995-8.163-8.184-8.197Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.239,12.237h-2.407v-2.4c0-.276-.224-.5-.5-.5s-.5,.224-.5,.5v2.4h-2.406c-.276,0-.5,.224-.5,.5s.224,.5,.5,.5h2.406v2.399c0,.276,.224,.5,.5,.5s.5-.224,.5-.5v-2.399h2.407c.276,0,.5-.224,.5-.5s-.224-.5-.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.480ee8091ebac71ccaa329492381d0ae.svg";
export { ForwardRef as ReactComponent };